var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "61px",
    viewBox: "0 0 248 61",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6523 61C51.6101 61 26.1639 42.0891 0.191315 4.61764C-0.159667 4.26744 0.015824 3.56703 0.366805 3.39193C0.717787 3.04173 1.24426 3.21683 1.59524 3.56703C28.2698 41.7389 53.8915 60.4747 78.1092 59.0739C97.7641 58.0233 111.277 44.3655 125.667 30.0072C139.706 15.8241 154.272 1.11563 175.331 0.0650227C198.847 -1.16068 223.24 14.9486 247.809 47.8675C248.16 48.2177 247.984 48.9181 247.633 49.0932C247.282 49.4434 246.756 49.2683 246.405 48.9181C222.187 16.5245 198.32 0.590324 175.507 1.81603C155.15 2.86663 140.759 17.2249 127.071 31.2329C113.207 45.241 98.8171 59.5992 78.4602 60.8249C77.4072 60.8249 76.5298 61 75.6523 61Z",
    id: "Path",
    fill: "#000000",
    fillOpacity: 0.8662807,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72);
export default __webpack_public_path__ + "static/media/72.07eb50d47d3c01a6dd7ee10b183df65a.svg";
export { ForwardRef as ReactComponent };